import { GitInfo } from '@common/git/GitInfo';
import { IDEModeProvider } from '@common/ide/IdeMode';
import { useLogMessage } from '@common/LogMessageContext';
import { useSelector } from '@common/performance/useSelector';
import { EditMode } from '@common/types';
import { Private_Routes } from '@common/url';
import { ExtractUrlPathVariables } from '@prophecy/interfaces/generic';
import { theme } from '@prophecy/theme';
import { Stack, OverlaySpinner, SIDE_NAVBAR_WIDTH } from '@prophecy/ui-v3';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { DatasetView } from './Dataset/DatasetView';
import { SummaryView } from './Dataset/SummaryView';
import { PipelineView } from './Pipeline/PipelineView';
import { LineageState, ViewType } from './types';

const StyledGlobalSpinner = styled(OverlaySpinner)`
  &&& {
    left: ${SIDE_NAVBAR_WIDTH};
  }
`;

const StyledStack = styled(Stack)`
  position: relative;
`;

const Footer = styled.div`
  background: ${theme.colors.gray100};
  width: 100%;
  z-index: 1;
`;
function getView(viewType: ViewType, column: string) {
  switch (viewType) {
    case ViewType.summary: {
      return <SummaryView column={column} />;
    }
    case ViewType.dataset: {
      return <DatasetView />;
    }
    case ViewType.pipeline: {
      return <PipelineView />;
    }
  }
}

export const Container = () => {
  const params = useParams<ExtractUrlPathVariables<typeof Private_Routes.Lineage_IDE.column.url>>();
  const projectId = decodeURIComponent(params.projectId || '');
  const column = decodeURIComponent(params.column || '');

  const loader = useSelector<LineageState, boolean>((state) => state.loader);
  const viewType = useSelector<LineageState, ViewType>((state) => state.metadata.metaInfo.viewType);
  const logMessage = useLogMessage();

  const view = getView(viewType, column);
  return (
    <IDEModeProvider value={EditMode.enabled}>
      <StyledStack height='100%' align='space-between' width='100%'>
        {view}
        <Footer>
          <GitInfo projectId={projectId} />
        </Footer>
      </StyledStack>

      {loader && <StyledGlobalSpinner tip={logMessage} />}
    </IDEModeProvider>
  );
};
